import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import {setTemplateTagSetId} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {setSelectedTemplateTagSetId} from 'MyAccount/ViewDesigns/redux/modules/accountPage';
import IconButton from 'material-ui/IconButton';
import {spaceToDashed} from 'cl-automation-utils';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
    transition: 'height 350ms cubic-bezier(0.23, 1, 0.32, 1)',
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 25,
  },
};

export default class InlineTip extends Component {
  getTipKey(props = this.props) {
    const {tipId} = props;
    return `tipDismissed-${tipId}`;
  }

  render() {
    const {children, style, tipId} = this.props;
    const tipKey = this.getTipKey();
    const hide = window.localStorage.getItem(tipKey);
    return (
      <div
        id={`cla-tip-${spaceToDashed(tipId)}`}
        style={{
          color: Colors.lightBlue700,
          backgroundColor: Colors.blue50,
          overflow: 'hidden',
          ...styles.root,
          ...style,
          height: hide ? 0 : style.height,
        }}
      >
        <FontIcon style={styles.infoBoxIcon} color={Colors.lightBlue800} className="material-icons">
          info
        </FontIcon>
        <div style={{flexGrow: 1}}>{children}</div>
        <IconButton
          className={'cla-close-button'}
          iconStyle={{color: Colors.lightBlue800}}
          onClick={() => {
            window.localStorage.setItem(tipKey, true);
            this.forceUpdate();
          }}
        >
          <FontIcon className="material-icons">close</FontIcon>
        </IconButton>
      </div>
    );
  }
}

InlineTip.propTypes = {
  children: PropTypes.node.isRequired,
};

InlineTip.defaultProps = {
  style: {},
};
